import { designSystemColors } from '@klv/shared/styles/colors';

export const textTagline = {
  headline: designSystemColors.sage,
};
